import axios from 'axios'
import store from '@/store'
import { message, Modal } from 'ant-design-vue'
import { getToken } from '@/utils/auth'
import md5 from 'js-md5'
import { generateUUID, getUUID, setUUID } from './index'
import { APP_VERSION, APPS } from '@/constants'

function myAxios(axiosConfig, urlType = 'default', responseType = 'default') {
  // const service = axios.create({
  //   baseURL: isTeacher ? process.env.VUE_APP_BASE_Teacher_API : process.env.VUE_APP_BASE_API,
  //   timeout: 1000 * 60 // request timeout
  // })
  let baseURL = ''
  switch (urlType) {
    case 'teacher-api':
      baseURL = process.env.VUE_APP_BASE_TEACHER_API
      break
    case 'common-api':
      baseURL = process.env.VUE_APP_BASE_COMMON_API
      break
    case 'aiClassroom':
      baseURL = process.env.VUE_APP_BASE_AI_API
      break
    case 'default':
      baseURL = process.env.VUE_APP_BASE_API
      break
    case 'full-url':
      baseURL = ''
      break
    case 'common-ai-api':
      baseURL = process.env.VUE_APP_COMMON_AI_API
      break
    default:
      baseURL = process.env.VUE_APP_BASE_API
      break
  }
  const service = axios.create({
    baseURL,
    timeout: 1000 * 60 // request timeout
  })

  const whiteList = ['/login']

  // request interceptor -- 请求拦截器
  service.interceptors.request.use(
    config => {
      // AI听说课堂处理
      if (store.getters.token || whiteList.indexOf(config.url) === -1) {
        const signStr = JSON.stringify(config.method === 'get' ? config.params : config.data)

        const release = APP_VERSION
        const device = 'web-pc'
        const thirdTypeId = store.getters.userInfo?.thirdPartyType
        let udid = getUUID()
        if (!udid) {
          udid = generateUUID(32)
          setUUID(udid)
        }
        const sign = md5(`${signStr || {}}` + '_Sts100#@')
        config.headers = {
          udid,
          sign,
          release: config?.headers['release'] ? config.headers['release'] : release,
          device: config?.headers['device'] ? config.headers['device'] : device,
          thirdTypeId: config?.headers['thirdTypeId'] ? config.headers['thirdTypeId'] : thirdTypeId,
          APPS,
          authToken: getToken(),
          ...config.headers
        }
      }
      return config
    },
    error => {
      // do something with request error
      return Promise.reject(error)
    }
  )

  // response interceptor -- 响应拦截器
  service.interceptors.response.use(
    response => {
      const { data } = response
      if (responseType === 'custom') {
        return data
      }
      // eslint-disable-next-line prefer-const
      data.state = Number(data.state)
      const { note, state } = data
      if (state !== 11 && state !== 101) {
        if (state === 55) {
          message.error('服务器错误', 1.5)
        } else {
          const errMsg = note || 'Error'
          message.error(errMsg, 1.5)
        }
        if (state === 22) {
          store.dispatch('user/resetAll').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
            Modal.destroy()
          })
        }
        return Promise.reject(new Error(note || 'Error'))
      } else if (data instanceof Blob) {
        return response
      } else {
        return data
      }
    },
    error => {
      if (responseType !== 'no-prompt') {
        console.log('err' + error) // for debug
        const errMsg = error.message.includes('timeout') ? '网络请求超时，请重试' : error.message
        message.error(errMsg, 1.5)
        return Promise.reject(error)
      }
    }
  )

  return service(axiosConfig)
}

export default myAxios
